import React, { useState } from "react";

const PorProfesional = () => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false); // Ocultar el mensaje de "Cargando" cuando el iframe termine de cargar
  };

  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Reserva tu hora</h1>

      {loading && <p className="text-center">Cargando...</p>}

      <iframe
        style={{
          overflow: "hidden",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
        src="https://agendamiento.reservo.cl/makereserva/agenda/30vusjJ030DTIf2g3F92BGA1X4t80b"
        width="100%"
        height="600"
        frameBorder="0"
        title="Reserva tu hora"
        onLoad={handleIframeLoad} // Detectar cuando el iframe ha terminado de cargar
      ></iframe>

      <p className="text-center">
        <a href="https://www.reservo.cl" target="_blank" rel="noopener noreferrer">
          Powered by Reservo
        </a>
      </p>
    </div>
  );
};

export default PorProfesional;